import { loggedIn } from '../../../routes/conditional';
import paths from '../../../routes/paths';
import {
  clearUpdateDeliveryAddressError,
  validateUserDeliveryAddress,
} from '../../../redux/modules/user';

export const page = {
  path: paths.createOrder.changeAddress,
  isAllowed: [loggedIn],
};

export const changeAddress = {
  actionPath: '/actions/create-order/change-delivery-address',
  inputLine1: 'line1',
  inputLine2: 'line2',
  inputCity: 'city',
  inputPostcode: 'postcode',
  action: ({ body }) =>
    validateUserDeliveryAddress(body, paths.createOrder.summary),
};

export const clearError = {
  actionPath: '/actions/create-order/clear-update-delivery-address-error',
  action: () => clearUpdateDeliveryAddressError(),
};
